import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  primaryColor: {
    color: '#7833FF',
  },
  listBenefits: {
    paddingLeft: theme.spacing(2.3),
    paddingBottom: theme.spacing(3),

    '& li': {
      lineHeight: 1.6,

      '&::marker': {
        color: '#7833FF',
      },
    },
  },
}));
